const Loader = (state = 0, action) => {
  switch (action.type) {
    case 'GET_LOADER':
      return state;
    case 'ADD_LOADER':
      state = state+1;
      return state;
    case 'MINUS_LOADER'  :
      state = state-1;
      return state;
    default:
      return state;
  }
};
export default Loader;
